(function () {
    'use strict';
    var controllerId = 'destMisura2BAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'common', 'datacontext', '_', fn_destMisura2BAdd]);

    function fn_destMisura2BAdd($scope, $uibModalInstance, common, datacontext, _) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        $scope.record = {};

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.destinatario);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return item;
        }

        

        // #region SUGGESTION PER ALLIEVO
        $scope.record.searchText = '';
        $scope.destId = 0;
        $scope.searchItems = [];
        //Sort Array
        $scope.searchItems.sort();
        //Define Suggestions List
        $scope.suggestions = [];
        $scope.suggestionsObj = [];
        //Define Selected Suggestion Item
        $scope.selectedIndex = -1;

        //Function To Call On ng-change
        $scope.search = function () {
            $scope.suggestions = [];
            $scope.suggestionsObj = [];
            //if ($scope.record.searchText == undefined) return;
            //if ($scope.record.searchText.length < 1) return; //numero minimo di caratteri
            return datacontext.destinatario_getAll(30, 1, $scope.record.searchText, 0, 0, 0, '2B', 0, 0, 0, 0, 0, 0, '', 6, '').then(function (data) {
                if (data) {
                    $scope.suggestions = [];
                    $scope.suggestionsObj = data;
                    data.forEach(function (item) {
                        $scope.suggestions.push(item.Cognome + ' ' + item.Nome + ' ' + item.CodiceFiscale);
                    });
                }
                if ($scope.suggestions.length == 1) {
                    $scope.AssignValueAndHide(0);
                }
            });
        };

        $scope.search();

        //Keep Track Of Search Text Value During The Selection From The Suggestions List  
        $scope.$watch('selectedIndex', function (val) {
            console.log('$watch');
            if (val !== -1) {
                $scope.record.searchText = $scope.suggestions[$scope.selectedIndex];
                $scope.record.Id = $scope.suggestionsObj[$scope.selectedIndex].Id;
                $scope.destinatario = $scope.suggestionsObj[$scope.selectedIndex];
            }
        });

        $scope.resetText = function () {
            if ($scope.record.Id > 0) {
                $scope.record.Id = '';
                $scope.destinatario = {};
                $scope.record.searchText = '';
                $scope.destId = 0;
            }
        };


        //Text Field Events
        //Function To Call on ng-keydown
        $scope.checkKeyDown = function (event) {
            if (event.keyCode === 40) {//down key, increment selectedIndex
                event.preventDefault();
                if ($scope.selectedIndex + 1 !== $scope.suggestions.length) {
                    $scope.selectedIndex++;
                }
            } else if (event.keyCode === 38) { //up key, decrement selectedIndex
                event.preventDefault();
                if ($scope.selectedIndex - 1 !== -1) {
                    $scope.selectedIndex--;
                }
            } else if (event.keyCode === 13) { //enter key, empty suggestions array
                return log('Clicca con il mouse per selezionare il destinatario. ');
                //event.preventDefault();
                //$scope.suggestions = [];
                //$scope.suggestionsObj = [];
            }
        };

        //Function To Call on ng-keyup
        $scope.checkKeyUp = function (event) {
            if (event.keyCode !== 8 && event.keyCode !== 46) {//delete or backspace     			
                if ($scope.record.searchText == "") {
                    $scope.suggestions = [];
                    $scope.suggestionsObj = [];
                }
            } else {
                if ($scope.record.Id > 0) {
                    $scope.record.Id = '';
                    $scope.destinatario = {};
                    $scope.record.searchText = '';
                    $scope.destId = 0;
                }
            }
        };
        //======================================

        //List Item Events
        //Function To Call on ng-click
        $scope.AssignValueAndHide = function (index) {
            console.log('hide');
            $scope.record.searchText = $scope.suggestions[index];
            $scope.record.Id = $scope.suggestionsObj[index].Id;
            $scope.destinatario = $scope.suggestionsObj[index];
            $scope.destId = $scope.record.Id;
            //console.info('suggestions prima', $scope.suggestions);
            $scope.suggestions = [];
            $scope.suggestionsObj = [];
        };

        // #endregion

   }
})();